import * as React from 'react';
import styled from '@emotion/styled';
import { FeatureLinks, featureLinksHover } from './FeatureLinks';
import { FeatureAvailability } from '../../../data/features';

export interface FeatureWidgetProps {
  label: string;
  children?: string;
  link?: string;
  docsLink?: string;
  tag?: string;
  systems?: readonly string[];
}

export const FeatureWidget: React.FC<FeatureWidgetProps> = (props) => {
  return (
    <S.Container>
      <S.Heading data-feature-header>
        <S.Kind>Feature</S.Kind>
        <FeatureLinks docsLink={props.docsLink} link={props.link} label={props.label} />
      </S.Heading>
      <S.Top>
        <S.Label>{props.label}</S.Label>
        {props.tag ? (
          <S.Tag
            title={props.tag === 'Enterprise' ? 'Enterprise plan feature' : 'Included with Pro'}
            $availability={props.tag === 'Enterprise' ? FeatureAvailability.ENTERPRISE : FeatureAvailability.PRO}
          >
            {props.tag}
          </S.Tag>
        ) : null}
      </S.Top>
      {props.children ? <S.Content>{props.children}</S.Content> : null}
      {props.systems?.length ? (
        <S.Connections>
          {props.systems.length === 1 ? 'Provided by' : 'Across'} {props.systems.join(' · ')}
        </S.Connections>
      ) : null}
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    ${featureLinksHover};
    background: ${(p) => p.theme.featureGraph.feature.background};
    padding: 18px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    min-width: 0;
    border: 1px solid ${(p) => p.theme.featureGraph.feature.border};
  `;

  export const Heading = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 32px;
  `;

  export const Kind = styled.span`
    color: ${(p) => p.theme.featureGraph.feature.accent};
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.08em;
  `;

  export const Connections = styled.div`
    color: ${(p) => p.theme.featureGraph.feature.accent};
    font-size: 12px;
    line-height: 1.5;
  `;

  export const Top = styled.div`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    column-gap: 10px;
  `;

  export const Label = styled.h3`
    margin: 0;
    color: ${(p) => p.theme.text.heading};
    font-size: 14px;
    font-weight: 500;
  `;
  export const Tag = styled.div<{ $availability: FeatureAvailability }>`
    color: ${(p) =>
      p.$availability === FeatureAvailability.ENTERPRISE ? p.theme.text.special2 : p.theme.pricing.background1};
    font-size: 14px;
    font-weight: 600;
  `;

  export const Content = styled.div`
    color: ${(p) => p.theme.text.paragraph};
    font-size: 13px;
    line-height: 1.6;
  `;
}
